module.exports = __webpack_public_path__ + "static/media/interactive.3a34904b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/interactive.svg
// module id = 284
// module chunks = 0